<template>
  <div>
    <ul class="nav nav-tabs menu-tabs mb-3">
      <li
        v-for="tab in tabs"
        :key="tab.key"
        class="nav-item"
        :class="{ active: activeTab === tab.key }"
      >
        <router-link class="nav-link" :to="tab.route">
          {{ tab.label ? tab.label : $t(tab.translationKey) }}
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    activeTab: String,
    tabs: {
      type: Array,
      required: true,
    },
    locale: {
      type: String,
      default: '',
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/shared/PageTabs.vue